import { Box, Button, Stack, Typography } from "@mui/material";
import { useRouteError } from "react-router";
import { useTranslation } from "react-i18next";

import { normaliseError, errorMessageKey } from "../lib/apiError";

/**
 * Last-resort boundary. A render crash inside a route lands here instead of a
 * blank page — which, on a clinical tool, is the difference between "something
 * broke, reload" and "the app is gone".
 */
export function RouteError() {
  const error = useRouteError();
  const { t } = useTranslation(["common", "errors"]);
  const normalised = normaliseError(error);

  return (
    <Box
      sx={{
        minHeight: "100dvh",
        display: "grid",
        placeItems: "center",
        p: 3,
        bgcolor: "background.default",
      }}
    >
      <Stack spacing={2} alignItems="center" textAlign="center" maxWidth={520}>
        <Typography variant="h2">{t("common:state.notFoundTitle")}</Typography>
        <Typography variant="body2" color="text.secondary">
          {t(errorMessageKey(normalised))}
        </Typography>
        <Button variant="contained" onClick={() => window.location.assign("/")}>
          {t("common:state.backHome")}
        </Button>
      </Stack>
    </Box>
  );
}
